import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ensureUrlProtocol' })
export class EnsureUrlProtocolPipe implements PipeTransform {
  transform(url: string): string {
    if (!url) {
      return url ?? '';
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
      return trimmedUrl;
    }

    const hasProtocol = /^https?:\/\//i.test(trimmedUrl);
    return hasProtocol ? trimmedUrl : `//${trimmedUrl}`;
  }
}
